<template>

    <v-card :loading="loading">
        <v-tabs color="primary" fixed-tabs v-model="tab">
            <v-tab v-for="tab of tabs" :value="tab.label">
                <v-icon :icon="tab.icon"></v-icon>
                {{ tab.label }}</v-tab>
        </v-tabs>
        <v-card-text>
            <v-tabs-window v-model="tab">

                <v-tabs-window-item value="Info">
                    <v-container>
                        <v-row>
                            <v-col v-for="item in dashboard_items" :key="item.target" v-if="vehicle" cols="6">
                                <v-card>
                                    <v-card-title class="text-left font-weight-bold">
                                        {{ item.label }}
                                    </v-card-title>
                                    <v-card-text class="text-left text-body-1">
                                        <template v-if="item.type == 'text'">
                                            {{ vehicle[item.target] || "N/A" }}
                                        </template>
                                        <template v-else-if="item.type == 'color'">
                                            <div class="color-input" :style="{ backgroundColor: vehicle[item.target] }">
                                                <p :style="{ color: getTextColor(vehicle[item.target]) }">
                                                    {{ vehicle[item.target] || "N/A" }}
                                                </p>
                                            </div>
                                        </template>
                                        <template v-else-if="item.type == 'icon'">

                                            <div class="d-flex flex-row align-center">
                                                <p class="mr-2">{{ vehicle[item.target] }}</p>
                                                <Icon :icon="vehicle[item.target]" :color="vehicle['boat_mark_color']">
                                                </Icon>
                                            </div>

                                        </template>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-title class="text-left font-weight-bold d-flex justify-space-between">
                                        <p>Descriptive</p>
                                        <div>
                                            <v-btn color="primary" prepend-icon="mdi-download" variant="text"
                                                text="Download" @click="downloadDescriptive()"></v-btn>
                                            <v-btn color="primary" prepend-icon="mdi-upload" text="Upload"
                                                variant="text" @click="dialogEditDescriptive = true"></v-btn>
                                        </div>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text>
                                        <v-table>
                                            <thead>
                                                <tr>
                                                    <th v-for="header in headersTable">
                                                        <template v-if="header != 'Visible'">
                                                            <strong>{{ header }}</strong>
                                                        </template>
                                                        <template v-else>
                                                            <strong>{{ header }}</strong>
                                                            <v-btn v-if="!changeVisible" variant="text"
                                                                icon="mdi-pencil" size="small"
                                                                @click="changeVisible = true"></v-btn>
                                                            <v-btn v-if="changeVisible" color="success" variant="text"
                                                                icon="mdi-check-bold" size="small"
                                                                @click="changeVisibleDescriptive()"></v-btn>
                                                        </template>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody class="text-left">
                                                <tr v-for="(item, index) in parseJSON(vehicle['descriptive'])">
                                                    <td>{{ item.name }}</td>
                                                    <td>{{ item.type }}</td>
                                                    <td>
                                                        <v-icon
                                                            v-if="(item.visible === 1 || item.visible === true) && !changeVisible">mdi-check-circle</v-icon>
                                                        <v-icon v-else-if="!changeVisible">mdi-close-circle</v-icon>
                                                        <v-checkbox v-else v-model="visibleCheckbox[index].visible"
                                                            density="compact" :hide-details="true"
                                                            :disabled="!visibleCheckbox[index].editable"></v-checkbox>
                                                    </td>
                                                    <td>{{ item.field }}</td>
                                                </tr>
                                            </tbody>
                                        </v-table>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tabs-window-item>
                <v-tabs-window-item value="Missions">

                    <v-btn class="mb-3" width="100%" prepend-icon="mdi-plus-thick" color="primary"
                        :disabled="!user_perms.find(e => e.name == 'edit_mission')" @click="dialogAddMission = true">
                        Add Mission
                    </v-btn>

                    <v-data-table-server :hide-default-footer="true" :loading="loading" :items="missions || []"
                        :items-length="missions.length" :headers="headers" @update:options="loadMissions">
                        <template v-slot:item.name="{ item }">
                            <v-btn color="primary" variant="text" :to="'/admin/mission/' + item.id">
                                <strong>{{ item.name }}</strong>
                            </v-btn>
                        </template>
                        <template v-slot:item.active_mission="{ item }">
                            <v-icon :icon="item.active_mission == 1 ? 'mdi-check-circle' : 'mdi-close-circle'"></v-icon>
                        </template>
                    </v-data-table-server>
                </v-tabs-window-item>


            </v-tabs-window>

        </v-card-text>
    </v-card>

    <v-overlay v-model="dialogAddMission" location="top" style="justify-content:center;align-items: center;">
        <AddVehicleMission :vehicle="vehicle" @close="dialogAddMission = false" />
    </v-overlay>

    <v-overlay v-model="dialogEditDescriptive" location="top" style="justify-content:center;align-items: center;"
        :persistent="persistentDialog">
        <UploadDescriptive :vehicle="vehicle" @close="dialogEditDescriptive = false"
            @persistent="(value) => persistentDialog = value" />
    </v-overlay>




</template>
<script setup>
import { useUserStore } from '@/store/userStore';
import { ref, computed, watchEffect, onUnmounted, onMounted } from 'vue';
import { useVehicleStore } from '@/store/vehicleStore';
import { storeToRefs } from 'pinia';
import { useMissionStore } from '@/store/missionStore';
import ConfirmForm from '../forms/ConfirmForm.vue';
import AddVehicleMission from '../forms/AddVehicleMission.vue';
import Icon from '@/components/icons/Icon.vue';
import { useNotificationStore } from '@/store/notificationStore';
import UploadDescriptive from './UploadDescriptive.vue';

const vehicleStore = useVehicleStore();
const missionStore = useMissionStore();
const { missions } = storeToRefs(missionStore);
const dialogAddMission = ref(false);
const dialogDeleteVehicle = ref(false);
const dialogEditDescriptive = ref(false);
const persistentDialog = ref(false);
const loading = ref(false);
const changeVisible = ref(false);
const tab = ref();
const tabs = [{ label: "Info", icon: "mdi-information" },
{ label: "Missions", icon: "mdi-compass" }];
const headersTable = ["Name", "Type", "Visible", "Field"];
const props = defineProps({
    vehicle: Object,
    user_perms: Object
});

const visibleCheckbox = ref([]);

onMounted(() => {
    let descriptive = JSON.parse(props.vehicle.descriptive);

    for (let key in descriptive) {
        let item = descriptive[key];
        if (item.field) {
            visibleCheckbox.value.push({ visible: true, editable: false });
        } else {
            visibleCheckbox.value.push({ visible: item.visible ? true : false, editable: true });
        }
    }
})






const getTextColor = (hexColor) => {
    if (!hexColor) return '#000';
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance > 128 ? '#000' : '#fff';
}


const headers = computed(() => [
    { title: 'Mission', align: 'center', sortable: false, key: 'name' },
    { title: 'Location', align: 'center', sortable: false, key: 'location' },
    { title: 'Active', align: 'center', sortable: false, key: 'active_mission' },
]);

const loadMissions = async () => {
    loading.value = true;
    await missionStore.fetchMissionsWithVehicle(props.vehicle.id);
    loading.value = false;
}

const changeVisibleDescriptive = async () => {
    let descriptive = JSON.parse(props.vehicle.descriptive);
    let index = 0;
    for (let key in descriptive) {
        descriptive[key].visible = visibleCheckbox.value[index].visible ? 1 : 0;
        index++;
    }
    await vehicleStore.changeVisibleDescriptive(props.vehicle.id, descriptive);
    changeVisible.value = false;
}

watchEffect((vehicle) => {
    if (props.mission) {
        loadMissions();
    }
});




const dashboard_items = [
    {
        label: 'Name',
        target: 'name',
        type: 'text'
    },
    {
        label: 'Vehicle address',
        target: 'mac',
        type: 'text'
    },
    {
        label: 'Icon',
        target: 'icon',
        type: 'icon'
    },
    {
        label: 'Icon color',
        target: 'boat_mark_color',
        type: 'color'
    },
    {
        label: 'Waypoint color',
        target: 'boat_waypoint_color',
        type: 'color'
    },
    {
        label: 'Route color',
        target: 'route_color',
        type: 'color'
    }
]

const getItemContent = (item) => {
    if (['start_date', 'end_date'].includes(item.target)) {
        return getFormattedDate(props.mission[item.target]);
    }
    if (['is_public', 'active_mission'].includes(item.target)) {
        return props.mission[item.target] === 1 ? "Yes" : "No";
    }
    return props.mission[item.target] || "N/A";
};


const deleteVehicle = async (vehicle) => {
    loading.value = true;
    await vehicleStore.designVehicle(vehicle.id, props.mission.id);
    dialogDeleteVehicle.value = false;
    loading.value = false;
}




const getFormattedDate = (date) => {
    if (date === undefined || date === 0 || date === null) return "--------"
    return new Date(date).toLocaleString();
}

const downloadDescriptive = () => {
    const data = props.vehicle['descriptive'];
    let jsonContent = '';
    try {
        jsonContent = typeof data === 'string' ? JSON.stringify(JSON.parse(data), null, 2) : JSON.stringify(data, null, 2);
    } catch (error) {
        useNotificationStore().setNotification('Error', 'Failing while trying to parse the json file', 'error', 'error');
        return;
    }

    const blob = new Blob([jsonContent], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'descriptiveFile_vehicle' + props.vehicle.id + '.json';
    link.click();

    URL.revokeObjectURL(url);
};


const parseJSON = (jsonString) => {
    try {
        const table = [];
        const obj = JSON.parse(jsonString);
        Object.entries(obj)
            .map(([key, value]) => {
                const row = {
                    name: key,
                    type: value.type,
                    visible: value.visible,
                    field: value.field
                }
                table.push(row);
            })
        return table;
    } catch (error) {
        return 'Error: JSON inválido';
    }
}

</script>

<style lang="css">
.color-input {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 30px;
    border-radius: 10px;
}
</style>
